import { render, staticRenderFns } from "./imgUpload.vue?vue&type=template&id=0177ffb0&scoped=true&"
import script from "./imgUpload.vue?vue&type=script&lang=js&"
export * from "./imgUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0177ffb0",
  null
  
)

export default component.exports